import { get } from 'lodash-es';

export default {
  methods: {
    moduleAnimationClasses(mod) {
      if (!this.allowModuleAnimation(mod)) return [];
      return get(mod, 'options.animations', [])
        .map((item) => ({ [`module-animation__${item.type}--${item.trigger}`]: true }));
    },
    allowModuleAnimation(mod) {
      return ['button', 'advanced_button', 'asset', 'upload'].includes(mod?.type);
    },
  },
};
